export const tabs = [
  {
    key: 'guidelines',
    icon: 'uil:file-alt',
    title: 'Content Guidelines',
  },
  {
    key: 'outline',
    icon: 'uil:layer-group',
    title: 'Outlines',
  },
  {
    key: 'faq',
    icon: 'uil:globe',
    title: 'FAQs',
  },
]

export const getFormattedValue = (title: string, value: number | undefined) => {
  const enUsFormat = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  })
  switch (title) {
    case 'Your Position':
      return value === 0 ? '>100' : value
    case 'Volume':
      return enUsFormat.format(value ?? 0)
    case 'Difficulty':
      return `${value}%`
    case 'Current Org. Traffic':
      return enUsFormat.format(value ?? 0)
    case 'Potential Traffic':
      return enUsFormat.format(value ?? 0)
    default:
      return value
  }
}
